export const languageMap = {
  html: "English",
  html_hi: "Hindi",
  html_pa: "Punjabi",
  html_gu: "Gujarati",
  html_mr: "Marathi",
  html_te: "Telugu",
  html_ta: "Tamil",
  html_kn: "Kannada",
  html_ml: "Malayalam",
};

export const languageKeys = Object.keys(languageMap);

export const filterHtmlFields = (data = {}) =>
  Object.fromEntries(
    Object.entries(data).filter(([key]) => key.startsWith("html")),
  );

/** Remove legacy maroon wrappers so view mode uses Qwikxy gray text */
export const normalizePolicyHtml = (html = "") => {
  if (!html || typeof html !== "string") return "";

  let content = html
    .replace(/<div[^>]*style="[^"]*color:\s*#A70000[^"]*"[^>]*>/gi, "")
    .replace(/<div[^>]*style="[^"]*color:\s*#a70000[^"]*"[^>]*>/gi, "")
    .replace(/color:\s*#A70000/gi, "color: #344054")
    .replace(/color:\s*#a70000/gi, "color: #344054")
    .replace(/color:\s*#A60000/gi, "color: #344054");

  // Strip one trailing wrapper div if we removed opening tag
  if (content.endsWith("</div>") && !content.includes("<div")) {
    content = content.replace(/<\/div>\s*$/i, "");
  }

  return content.trim();
};

export const preparePolicyForSave = (contentMap = {}) =>
  Object.fromEntries(
    Object.entries(contentMap).map(([lang, content]) => [lang, content || ""]),
  );
